export default __webpack_public_path__ + "static/media/Premium.5d9f31c4.webp";